import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 57;

export const migration_56_57:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface )
        {
            const viewportLayoutProp = getViewportLayoutPropSnapshotValue();

            designState.surface.props = {
                [viewportLayoutProp.id]: viewportLayoutProp,
                [designState.surface.scrollbarProp.id]: designState.surface.scrollbarProp
            };

            designState.surface.eventProps = {
                [designState.surface.onApplicationLoadProp.id]: designState.surface.onApplicationLoadProp,
                [designState.surface.onViewportResizeProp.id]: designState.surface.onViewportResizeProp
            };

            delete designState.surface.scrollbarProp;
            delete designState.surface.onApplicationLoadProp;
            delete designState.surface.onViewportResizeProp;
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};

function getViewportLayoutPropSnapshotValue()
{
    return {
        'id': '78c2df56-ce3e-4c2a-beaa-fec2812c4fd1',
        'name': 'viewportLayout',
        'group': 'baseProperty',
        'bindingIds': [],
        '_value': {
            'deviceType': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Custom',
                'values': [
                    'Desktop',
                    'Tablet',
                    'Mobile',
                    'Custom'
                ]
            },
            'deviceOrientation': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Horizontal',
                'values': [
                    'Horizontal',
                    'Vertical'
                ]
            },
            'desktopDevice': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Desktop',
                'values': [
                    'Desktop',
                    'Desktop HD'
                ]
            },
            'tabletDevice': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Tablet',
                'values': [
                    'Tablet',
                    '7.9" iPad mini',
                    '10.2" iPad',
                    '10.5" iPad Air',
                    '11" iPad Pro',
                    '12.9" iPad Pro',
                    'Nexus 7',
                    'Nexus 9',
                    'Nexus 10'
                ]
            },
            'mobileDevice': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Mobile',
                'values': [
                    'Mobile',
                    'iPhone 8',
                    'iPhone 8 Plus',
                    'iPhone SE',
                    'iPhone 11 Pro',
                    'iPhone 11',
                    'iPhone 11 Pro Max',
                    'Android',
                    'Pixel 2',
                    'Pixel 2 XL',
                    'Pixel 3',
                    'Pixel 3 XL',
                    'Galaxy S10e',
                    'Galaxy S10',
                    'Galaxy S10+'
                ]
            },
            'customWidth': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 768
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'customHeight': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 1024
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            }
        }
    };
}
